import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            color: "#b8f303",
            border: "2px solid #b8f303",
            borderRadius: "999px",
            fontFamily: "'Unbounded', sans-serif",
            fontWeight: 700,
            fontSize: "12px",
          },
        }}
      />
    </div>
  );
}

export default App;
